import ScriptClient from './ScriptClient';
import { Http } from 'src/api/Http';

export * from './ScriptClient.types';
export { ScriptClient };

// Create and export a singleton instance
const scriptClient = new ScriptClient(new Http());
export default scriptClient;
